import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";

import AddIcon from "@mui/icons-material/Add";

import { Button, CircularProgress } from "@mui/material";
import { getURLBase, updateParentHeight } from "../utils/helperFns";
import axios from "axios";
import AccountDetails from "../components/ui-components/money-tab/AccountDetails";

import Divider from '@mui/material/Divider';
import { GradientButton } from "../components/ui-components/GradientButton";
import wyzrTheme from "../styles/customTheme";
import SweepAccountDetails from "../components/ui-components/money-tab/SweepAccountDetails";


export class TotalBalance extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/totalbalance"
        this.state = {
            isReady: false,
            isSweepReady: false,
            showSweepDetails: this.props.openSweep ? true : false,
            showAccountDetails: false,
            singleTypeAccounts: [],
        }
    }

    componentDidMount() {
        if (!this.state.isReady) {
            axios.post(this.url, { gid: this.props.gid }).then(
                (response) => {
                    var sweepAccount = response.data.body.categories.pop();
                    this.setState({ response: response.data.body, sweepAccount: sweepAccount })
                    this.setState({ isReady: true })
                }

            )
            axios.post(getURLBase(true) + "/accounts", { gid: this.props.gid }).then(
                (response) => {
                    console.log("accounts", response.data.body)
                    this.setState({ singleTypeAccounts: response.data.body.data })
                    this.setState({ isSweepReady: true })
                }
            )
            axios.post(getURLBase(true) + "/maxyoucansave", { gid: this.props.gid }).then(
                (response) => {
                    this.processData(response.data.body)
                }
            )
        }



    }

    toggleSweepScreen = () => {
        var show = this.state.showSweepDetails;
        show = !show;
        this.setState({
            showSweepDetails: show
        }, () => {
            updateParentHeight("parent_TotalBalance", "child_SweepAccountDetails", this.state.showSweepDetails);
        });
    }

    toggleAccountDetails = () => {
        var show = this.state.showAccountDetails;
        show = !show;
        this.setState({ showAccountDetails: show },
            () => {
                updateParentHeight("parent_TotalBalance", "child_AccountDetails", this.state.showAccountDetails);
            });
    }

    processData = (response) => {
        let textdata = response.text;
        let piedata = [];

        let c = new Map(Object.entries(response.credit));
        let d = new Map(Object.entries(response.debit));

        let total = 0;
        let to_be_saved = 0;
        for (const [k, v] of d.entries()) {
            piedata.push({ name: k, value: v });
            total += v;
            to_be_saved += v;
        }

        for (const [k, v] of c.entries()) {
            piedata.push({ name: k, value: v });
            total += v;
        }

        this.setState({
            piedata: piedata,
            textdata: textdata,
            total: total,
            max_save_amt: to_be_saved
        });
    };

    render() {

        const Categories = ({ response, clickable }) => (
            <>
                {response.categories.map((envelop, index) => (
                    <Grid key={index} item md={6} xs={6} maxWidth="md" >
                        <Button
                            variant="text"
                            sx={{ width: "100%", padding: 0, width: "100%" }}
                            onClick={clickable === true ? () => {
                                this.setState({ accountTotalToOpen: envelop.total, accountTypeToOpen: envelop.category });
                                this.toggleAccountDetails()
                            } : () => { return null }}>
                            <Box p={2} borderRadius={3} boxShadow={3} width={"100%"} height={"100%"}>
                                <Typography variant="body1"
                                    fontWeight={700}
                                    marginBottom={4}
                                    color="primary.main"
                                    align="center"
                                    fontSize={"1.2rem"}
                                    gutterBottom sx={{ textTransform: "capitalize" }}>
                                    {envelop.category}
                                </Typography>

                                <Typography variant="h4" color="text.primary">

                                    {envelop.prefix}£ {Math.round(envelop.total)}
                                    {/* <Typography size="small" fontWeight="600" variant="body1" sx={{ display: "inline" }}>.00
                                    </Typography> */}
                                </Typography>
                            </Box>
                        </Button>
                    </Grid>
                ))}

                <Grid item md={6} xs={6} maxWidth="md" >
                    <Button
                        variant="text"
                        color="secondary"
                        sx={{ padding: 0, width: "100%", boxShadow: 3, backgroundColor: wyzrTheme.palette.primary.light }}
                        onClick={clickable === true ? this.toggleSweepScreen : null}>
                        <Box p={2}>
                            <Typography variant="body1"
                                fontWeight={700}
                                fontSize={"1.2rem"}
                                marginBottom={4}
                                color="primary.main"
                                align="center"
                                gutterBottom sx={{ textTransform: "uppercase" }}>
                                {this.state.sweepAccount.category}
                            </Typography>
                            <Typography variant="h4" color="text.primary">
                                {console.log(this.state.sweepAccount)}
                                £ {Math.round(this.state.sweepAccount.total)}
                                {/* <Typography size="small" fontWeight="600" variant="body1" sx={{ display: "inline" }}>.00
                                </Typography> */}
                            </Typography>
                        </Box>
                    </Button>
                </Grid>
            </>
        );

        const WidgetData = () => (
            <Card className={"widgetCard cardShadow " + `${this.state.isReady ? (`${(this.state.response.total === null /*|| this.state.response.total === 0*/) ? "blur" : ""}`) : ""}`} id="parent_TotalBalance">
                <Typography variant="h4" fontWeight={700} align="center" gutterBottom>Total Balance</Typography>
                <Typography variant="h2" fontSize="2rem" fontWeight={700} align="center" gutterBottom> {this.state.isReady ? `£ ${this.state.response.total}` : null}</Typography>
                <Divider light />
                <CardContent>
                    {this.state.isReady ?
                        <>
                            <Grid maxWidth={360} mx="auto">
                                <Grid container rowSpacing={{ xs: 1, sm: 2 }} columnSpacing={{ xs: 1, sm: 2 }}  >
                                    <Categories response={this.state.response} clickable={this.state.response.total != null ? true : false} />
                                </Grid>
                            </Grid>
                            <Grid maxWidth={360} mx="auto" marginTop={5}>

                                <GradientButton textTransformtype="capitalize" startIcon={<AddIcon />} sx={{ width: "100%", fontSize: "1rem", fontWeight: 800 }}
                                    onClick={() => {

                                        axios.post(getURLBase(true) + "/addaccountclick", { gid: this.props.gid }).then(
                                            (response) => {
                                                // window.open(response.data.body.url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes')
                                                window.location.href=response.data.body.url;
                                            }
                                        )
                                    }}
                                >
                                    Add Account
                                </GradientButton>

                                <Button sx={{
                                    margin: "0 auto",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    // marginY: "0.5rem",
                                    // marginTop: "-0.5rem",
                                    // fontSize: "0.7rem",
                                    padding: "2px",
                                    marginTop: ".7rem",
                                    marginBottom: "-0.4rem"
                                }}
                                    onClick={() => this.props.setEmbedUrl(this.state.response.tutorial_iframe)}
                                >
                                    See how this works <img src="/tutorial-icon.png" style={{ width: "40px", padding: "5px" }} />
                                </Button>
                            </Grid>
                        </>
                        : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>
                    }
                </CardContent>
                {
                    this.state.showAccountDetails ?
                        <AccountDetails
                            toggleHandler={this.toggleAccountDetails}
                            type={this.state.accountTypeToOpen}
                            total={this.state.accountTotalToOpen}
                            gid={this.props.gid}
                            singleTypeAccounts={this.state.singleTypeAccounts}
                            accounts={this.state.isSweepReady ? this.state.singleTypeAccounts : null} />
                        : null
                }
                {
                    this.state.showSweepDetails ?
                        <SweepAccountDetails
                            gid={this.props.gid}
                            max_save={this.props.max_save ? this.state.max_save_amt : null}
                            toggleHandler={this.toggleSweepScreen}
                            setEmbedUrl={this.props.setEmbedUrl}
                        />
                        : null
                }
            </Card>
        );

        return (
            <>
                <WidgetData />
            </>
        );
    }
}

export default TotalBalance;
